<script setup lang="ts">
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/landingPage/ui/accordion";

interface FAQProps {
  question: string;
  answer: string;
  value: string;
}

const FAQList: FAQProps[] = [
  {
    question: "À qui s'adresse Autrement Capable ?",
    answer: "La plateforme s'adresse aux jeunes neurodivergents (notamment avec TSA) qui souhaitent découvrir leurs forces et construire leur projet professionnel, aux accompagnateurs (parents, enseignants, éducateurs, psychologues), et aux entreprises inclusives souhaitant recruter des talents neurodivergents.",
    value: "item-1",
  },
  {
    question: "Comment fonctionne le système de matching ?",
    answer:
      "Notre algorithme d'intelligence artificielle analyse les données collectées via les mini-jeux et activités pour créer un profil unique. Il recommande ensuite des métiers, formations et entreprises compatibles selon vos compétences, préférences, localisation et type de travail souhaité.",
    value: "item-2",
  },
  {
    question: "Mes données personnelles sont-elles sécurisées ?",
    answer:
      "Absolument. Toutes vos données sont chiffrées et hébergées de façon sécurisée. Nous respectons le RGPD et vous gardez le contrôle total sur les informations que vous partagez. Vous pouvez à tout moment consulter, modifier ou supprimer vos données.",
    value: "item-3",
  },
  {
    question: "Quel est le rôle de l'accompagnateur sur la plateforme ?",
    answer: "Les accompagnateurs ont accès à un tableau de bord dédié pour suivre les progrès des jeunes, analyser les données, communiquer via messagerie sécurisée, ajouter des notes et recommandations, et créer des ateliers interactifs personnalisés.",
    value: "item-4",
  },
  {
    question: "Comment les entreprises peuvent-elles utiliser la plateforme ?",
    answer: "Les entreprises peuvent publier des offres d'emploi inclusives, découvrir des profils de candidats neurodivergents, bénéficier de formations à la neurodiversité et suivre l'intégration des candidats recrutés pour assurer une transition réussie.",
    value: "item-5",
  },
];
</script>

<template>
  <section
    id="faq"
    class="container md:w-[700px] mx-auto py-24 sm:py-32"
  >
    <div class="text-center mb-8">
      <h2 class="text-lg text-[#ff9500] text-center mb-2 tracking-wider">FAQ</h2>

      <h2 class="text-3xl md:text-4xl text-center font-bold">
        Questions fréquentes
      </h2>
    </div>

    <Accordion
      type="single"
      collapsible
      class="AccordionRoot"
    >
      <AccordionItem
        v-for="{ question, answer, value } in FAQList"
        :key="value"
        :value="value"
      >
        <AccordionTrigger class="text-left"> {{ question }} </AccordionTrigger>

        <AccordionContent>{{ answer }}</AccordionContent>
      </AccordionItem>
    </Accordion>

    <h3 class="font-medium mt-4">
      Vous avez d'autres questions ?
      <a
        href="#contact"
        class="text-[#ff9500] underline"
        >Contactez-nous</a
      >
    </h3>
  </section>
</template>
